import React, {Component} from 'react';
import {Route} from 'react-router-dom';

// Components

import Navigation from './../header/navigation';
import BreadCrums from './breadcrums';
import Footer from './../footer';
import CustomPage from './../../common/page';
import Counterlist from './../../modules/Counterlist';
class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            menuList: []
        };
    }
    componentDidMount() {
        console.log(this.props.match);
    }
    menuData(evnt) {
        this.setState((state) => ({menuList: evnt}));
    }
    render() {
        const {id, slug} = this.props.match.params;
        return (
            <div className="body-wraper">
                {(id === 'tv-screen') 
                    ? <React.Fragment><Counterlist {...this.props} {...this.state}/></React.Fragment>
                    : <React.Fragment>
                        {(slug === 'start-counter') 
                            ? <React.Fragment>
                                <Route
                                    path={`/${this.props.match.params.id}/:slug?`}
                                    render={(props) => <CustomPage {...this.props} {...this.state}/>}
                                />
                              </React.Fragment>
                            : <React.Fragment>
                                <Navigation {...this.props} menuData={this.menuData.bind(this)}></Navigation>
                                <div className="body-container" id="bodycontainer">
                                    {id !== 'nurse-display' && <BreadCrums {...this.props} {...this.state}></BreadCrums>}
                                    <Route
                                        path={`/${this.props.match.params.id}/:slug?`}
                                        render={(props) => <CustomPage {...this.props} {...this.state}/>}
                                    />
                                </div>
                                <Footer {...this.props} {...this.state}></Footer>
                              </React.Fragment>
                        }
                      </React.Fragment>
                }
            </div>
        );
    }
}

export default Body;
